import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "../property-list-header/property-list-header.module.scss";
import { PropertyListHeaderProps } from "./property-list-header.interface";
// import MobileSliderMenu from "../../common/mobile-slider";
// import SortingMobileSliderMenuBody from "../../common/sorting-mobile-slider-menu-body";
import { TieredMenu } from "primereact/tieredmenu";
import { Sidebar } from "primereact/sidebar";
import { labelFunction } from "../../../utils/utils";
import { SortApplied } from "../../investor/amplitude";

const PropertyListHeader = ({
  title,
  sub_title,
  type
}: PropertyListHeaderProps) => {
  const menu = useRef<any>(null);
  const [selectedSortMenuItem, setSelectedSortMenuItem] = useState<any>(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const sort = searchParams.get("sort");
    const order = searchParams.get("order");
    return labelFunction(sort, order);
  });
  // const [searchParams] = useSearchParams();
  const [visibleDrawer, setVisibleDrawer] = useState(false);
  const [, setSearchParams] = useSearchParams();
  // const [property, setProperty] = useState(() => searchParams.get("sort"));

  // const handleReset = () => {
  //   setProperty("");
  // };
  useEffect(() => {}, []);
  function handleSort(name: string, value: string) {
    // const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort", name);
    searchParams.set("order", value);
    if (type === "investor") {
      SortApplied({
        name: name,
        order: value
      });
    }
    setSearchParams(searchParams);
    setVisibleDrawer(false);
  }

  const sortItems: any = [
    {
      label: (
        <div className={styles.sortLabel} id="Property Added Newest">
          <div className={styles.first}>Property Added</div>
          <div className={styles.second}> — </div>
          <div>Newest</div>
        </div>
      ),
      command: () => handleSort("updatedAt", "DESC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="Property Added Oldest">
          <div className={styles.first}>Property Added</div>
          <div className={styles.second}> — </div>
          <div>Oldest</div>
        </div>
      ),
      command: () => handleSort("updatedAt", "ASC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="By Price Highest To Lowest">
          <div className={styles.first}>By Price</div>
          <div className={styles.second}> — </div>
          <div>Highest To Lowest</div>
        </div>
      ),
      command: () => handleSort("askingPrice", "DESC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="By Price Lowest To Highest">
          <div className={styles.first}>By Price</div>
          <div className={styles.second}> — </div>
          <div>Lowest to Highest</div>
        </div>
      ),
      command: () => handleSort("askingPrice", "ASC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="Year Build Highest To Lowest">
          <div className={styles.first}>Year Build</div>
          <div className={styles.second}> — </div>
          <div>Highest to Lowest</div>
        </div>
      ),

      command: () => handleSort("yearBuilt", "DESC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="Year Build Lowest To Highest">
          <div className={styles.first}>Year Build</div>
          <div className={styles.second}> — </div>
          <div>Lowest to Highest</div>
        </div>
      ),
      command: () => handleSort("yearBuilt", "ASC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="Square Feet Highest To Lowest">
          <div className={styles.first}>Square Feet</div>
          <div className={styles.second}> — </div>
          <div>Highest to Lowest</div>
        </div>
      ),
      command: () => handleSort("sqft", "DESC")
    },
    {
      label: (
        <div className={styles.sortLabel} id="Square Feet Lowest To Highest">
          <div className={styles.first}>Square Feet</div>
          <div className={styles.second}> — </div>
          <div>Lowest to Highest</div>
        </div>
      ),
      command: () => handleSort("sqft", "ASC")
    }
  ];
  const handleMenuItemClick = (label: any, callback: any) => {
    setSelectedSortMenuItem(label);
    callback();
  };
  const sortMenuItems = sortItems.map((item: any) => ({
    ...item,
    className:
      `${`${selectedSortMenuItem}`}` === `${item.label.props.id}`
        ? styles.selected
        : "",
    command: () => handleMenuItemClick(item.label.props.id, item.command)
  }));

  useEffect(() => {
    if (window.innerWidth <= 768) {
      localStorage.setItem("layout", "grid");
    }
  }, [window.innerWidth]);

  return (
    <div className={styles.headerWrap}>
      <div className={styles.titleWrap}>
        <div className={styles.title}>{title}</div>
        <p>{sub_title}</p>
      </div>
      {/* <MobileSliderMenu
        title="Sorting"
        visibleDrawer={visibleDrawer}
        setVisibleDrawer={setVisibleDrawer}
        handleReset={handleReset}
      >
        <SortingMobileSliderMenuBody
          reset={handleReset}
          property={property}
          setProperty={setProperty}
        />
      </MobileSliderMenu> */}
      <Sidebar
        visible={visibleDrawer}
        position="bottom"
        onHide={() => setVisibleDrawer(false)}
        className={styles.sortDrawer}
      >
        <div className={styles.bidWrapHeading}>
          <div className={styles.PreviousHeading}>Sort By</div>
          <img
            src="/images/close-bid.svg"
            alt=""
            onClick={() => setVisibleDrawer(false)}
          />
        </div>
        {sortMenuItems.map((item: any) => (
          <div
            key={item.label}
            id={item.label.props.id}
            className={`${styles.sortLabel} ${
              selectedSortMenuItem === item.label.props.id
                ? styles.selected
                : ""
            }`}
            onClick={item.command}
          >
            {item.label}
          </div>
        ))}
      </Sidebar>
      <div className={styles.sort} onClick={() => setVisibleDrawer(true)}>
        <img src="/images/sort.svg" alt="" />
      </div>
      <div
        className={`${
          selectedSortMenuItem.length > 0 ? styles.dropdownSelected : ""
        }  ${styles.dropdown}`}
        onClick={(e: any) => menu.current.toggle(e)}
      >
        {selectedSortMenuItem.length > 0 ? (
          <img src="/images/sort-web-selected.svg" alt="" />
        ) : (
          <img src="/images/sort-web.svg" alt="" />
        )}
      </div>
      <TieredMenu
        className={styles.sortMenu}
        model={sortMenuItems}
        popup
        ref={menu}
      />
    </div>
  );
};

export default React.memo(PropertyListHeader);
